// src/admin/components/AgentCommissionReport.js
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { toast } from 'react-toastify';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  CircularProgress,
  TextField,
} from "@mui/material";

/* ================= DATE HELPERS ================= */
const today = new Date();
const formatDate = (d) => d.toISOString().split("T")[0];

const defaultFromDate = formatDate(today);
const defaultToDate = formatDate(
  new Date(today.setDate(today.getDate() + 1))
);
const company = JSON.parse(sessionStorage.getItem("companyDetails") || "{}");
const Companycurrency = company?.currency ?? "";
export default function AgentCommissionReport() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  const [fromDate, setFromDate] = useState(defaultFromDate);
  const [toDate, setToDate] = useState(defaultToDate);

  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();

  /* ================= FETCH COMMISSION REPORT ================= */
  useEffect(() => {
    if (!fromDate || !toDate) return;

    setLoading(true);

    fetch(
      `${config.API_BASE_URL}/Home/GetallAgentCommsion/${fromDate}/${toDate}/${company?.id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("GetallAgentCommsion API response:", data);
        setRows(data || []);
      })
      .catch((err) => {
        console.error("GetallAgentCommsion API error:", err);
        toast.error("Failed to load agent commission report");
      })
      .finally(() => setLoading(false));
  }, [token, fromDate, toDate]);

  /* ================= SEARCH FILTER ================= */
  const filteredRows = useMemo(() => {
    if (!search) return rows;

    const q = search.toLowerCase();

    return rows.filter((r) =>
      [
        r.id,
        r.name,
        r.commissionPercent,
        r.bookingPrice,
        r.commissionAmount,
      ]
        .join(" ")
        .toLowerCase()
        .includes(q)
    );
  }, [rows, search]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" fontWeight="bold" mb={2} textAlign="center">
        💰 Agent Commission Report
      </Typography>

      {/* 🔍 FILTER BAR */}
      <Box
        mb={3}
        display="flex"
        gap={2}
        justifyContent="flex-end"
        flexWrap="wrap"
      >
        <TextField
          size="small"
          type="date"
          label="From Date"
          InputLabelProps={{ shrink: true }}
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />

        <TextField
          size="small"
          type="date"
          label="To Date"
          InputLabelProps={{ shrink: true }}
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />

        <TextField
          size="small"
          label="Search..."
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ width: 220 }}
        />
      </Box>

      <Paper elevation={3}>
        <TableContainer sx={{ maxHeight: "75vh" }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {[
                  "#",
                  "Booking Id",
                  "Agent Name",
                  "Commission %",
                 `Booking Price (${Companycurrency})`,
                 `Commission Amount (${Companycurrency})`,
                ].map((h) => (
                  <TableCell key={h} sx={{ fontWeight: "bold" }}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {filteredRows.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              ) : (
                filteredRows.map((r, i) => (
                  <TableRow key={i}>
                    <TableCell>{i + 1}</TableCell>

                    <TableCell
                      sx={{
                        color: "primary.main",
                        cursor: "pointer",
                        textDecoration: "underline",
                        fontWeight: "bold",
                      }}
                      onClick={() => navigate("/admin/Bookingfilter")}
                    >
                      {r.id || "-"}
                    </TableCell>

                    <TableCell>{r.name || "-"}</TableCell>
                    <TableCell>{r.commissionPercent ?? 0}%</TableCell>
                    <TableCell>{Companycurrency}{r.bookingPrice ?? 0}</TableCell>
                    <TableCell sx={{ fontWeight: "bold", color: "green" }}>
                     {Companycurrency}{r.commissionAmount ?? 0}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}
